import { Component, OnInit } from '@angular/core';
import { DBService } from '../../services/db.service';
import { Partner } from '../../model/partner';
import { Router } from '@angular/router';
import { MatDialog, Sort } from '@angular/material';
import { ConfirmDeleteComponent } from '../partials/confirm-delete/confirm-delete.component';

declare var Materialize: any;

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.css'],
  providers: [DBService]
})
export class PartnersComponent implements OnInit {

  loading: boolean;

  list: Partner[];
  displayList: Partner[];

  searchText: string;

  constructor(public dialog: MatDialog, private router: Router, private dbService: DBService) {
    this.displayList = [];
    this.loading = true;
    this.searchText = '';

    this.loadData();
  }

  ngOnInit() {
  }

  private loadData() {
    this.dbService.listWithUIDs<Partner>('/partners')
      .then(list => {
        this.list = list;
        this.onSearchChange(this.searchText);
        this.loading = false;
      })
      .catch(error => console.log(error));
  }

  onSearchChange(searchValue: string ) {
    this.searchText = searchValue.toLowerCase();

    this.displayList = this.list
      .sort((e1, e2) => e1.name.localeCompare(e2.name))
      .filter(item => item.name.toLowerCase().includes(this.searchText) ||
                      item.cpf.toLowerCase().includes(this.searchText) ||
                      item.address.city.toLowerCase().includes(this.searchText) ||
                      item.address.state.toLowerCase().includes(this.searchText));
  }

  sortData(sort: Sort) {
    if (!sort.active || sort.direction == '') {
      return;
    }

    this.displayList = this.displayList.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'name': return this.compare(a.name, b.name, isAsc);
        case 'cpf': return this.compare(a.cpf, b.cpf, isAsc);
        case 'address': return this.compare(a.address.city, b.address.city, isAsc);
        default: return 0;
      }
    });
  }

  private compare(a, b, isAsc) {
    return a.localeCompare(b) * (isAsc ? 1 : -1);
  }

  goToNew() {
    this.router.navigate(['parceiros/novo']);
  }

  openDeleteModal(partner: Partner) {
    let dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      height: 'auto',
      width: '600px',
      data: { name: partner.name }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) this.confirmDelete(partner.uid);
    });
  }

  private confirmDelete(uid: string) {
    this.loading = true;
    this.dbService.remove('/partners', uid)
      .then(() => {
        Materialize.toast('Parceiro removido com sucesso', 2000)
        this.loadData();
      })
      .catch(error => console.log(error));
  }
}




// WEBPACK FOOTER //
// ./src/app/pages/partners/partners.component.ts